import type { HealthScoreBadgeProps } from "../_types";

const sizeClasses = {
  sm: "w-8 h-8 text-xs",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-lg",
};

const statusColors = {
  healthy: {
    bg: "bg-[var(--color-success)]/20",
    text: "text-[var(--color-success)]",
    border: "border-[var(--color-success)]/30",
  },
  warning: {
    bg: "bg-[var(--color-warning)]/20",
    text: "text-[var(--color-warning)]",
    border: "border-[var(--color-warning)]/30",
  },
  blocked: {
    bg: "bg-[var(--color-error)]/20",
    text: "text-[var(--color-error)]",
    border: "border-[var(--color-error)]/30",
  },
  unknown: {
    bg: "bg-[var(--color-surface)]",
    text: "text-[var(--color-text-muted)]",
    border: "border-[var(--color-border)]",
  },
};

export function HealthScoreBadge({ score, status, size = "md" }: HealthScoreBadgeProps) {
  const colors = statusColors[status];

  return (
    <div
      className={`${sizeClasses[size]} ${colors.bg} ${colors.border} border rounded-full flex items-center justify-center font-semibold ${colors.text}`}
      title={`Health score: ${score}/100`}
    >
      {score}
    </div>
  );
}
